import React from "react";
import toast from "react-hot-toast";

const FilePreviewModal = ({
  isOpen,
  previewUrl,
  onClose,
  title = "Алдын ала қарау",
  showDownloadHint = true,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-[1px] flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white w-11/12 md:w-4/5 lg:w-5/6 xl:w-4/5 h-5/6 rounded-xl shadow-lg flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b bg-gray-50">
          <div className="flex items-center gap-4">
            <h2 className="text-xl font-bold text-[#674DA2]">{title}</h2>
            {/* {showDownloadHint && (
              <span className="text-sm bg-blue-100 text-blue-800 px-3 py-1 rounded-full">
                Толық нұсқа үшін жүктеп алыңыз
              </span>
            )} */}
          </div>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-black font-bold text-lg px-2 py-1 rounded hover:bg-gray-200 transition-colors"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden">
          {previewUrl ? (
            <iframe
              src={previewUrl}
              className="w-full h-full border-0"
              title="File Preview"
              onError={() => {
                toast.error("Файлды көрсету мүмкін болмады");
              }}
            />
          ) : (
            <div className="flex items-center justify-center h-full text-gray-500">
              <div className="text-center">
                <div className="animate-spin h-8 w-8 border-4 border-gray-300 border-t-transparent rounded-full mx-auto mb-4" />
                <p>Файл жүктелуде...</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
